import { render, staticRenderFns } from "./TaskThemes.vue?vue&type=template&id=05fc478c&scoped=true&"
import script from "./TaskThemes.vue?vue&type=script&lang=js&"
export * from "./TaskThemes.vue?vue&type=script&lang=js&"
import style0 from "./TaskThemes.vue?vue&type=style&index=0&id=05fc478c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fc478c",
  null
  
)

export default component.exports